import history from '../../../history/history';
import relationshipService from '../../../services/relationship/RelationshipService';
import {captureError} from '../../../utils/log';
import {getSearchValues} from '../../../utils/search';

export const getSubcontractors = ({userId, pageSize}) => new Promise((resolve, reject) => {
  const {queryString = '', page = 0} = getSearchValues(history.location.search);

  const searchParams = [
    userId,
    queryString,
    page,
    pageSize
  ];

  relationshipService.searchSubcontractorsByUser(...searchParams)
    .then(({subcontractors, totalCount}) => {
      resolve({subcontractors, totalCount});
    })
    .catch(error => {
      captureError('Error while searching for subcontractors', error);
      reject();
    });
});
